import map from 'lodash/map';

import styles from './CardParameters.module.scss';

const CardInlineParameters = ({
  parameters = [],
  className = '',
  emphasize = false,
}) => {

  const parameterValues = map(parameters, parameter => parameter.value);

  return (
    <div className={`${styles.parameters} ${emphasize ? styles.emphasized : ''} ${className}`}>
      {parameterValues.join(', ')}
    </div>
  );
};

export default CardInlineParameters;
